import { Injectable } from "@angular/core";
import { AngularFirestore, } from "@angular/fire/compat/firestore";
import * as firebase from 'firebase/compat/app'
import 'firebase/firestore'
import { Subject, Observable } from "rxjs";
import { ConfigService } from "src/app/shared/config";
import { ProductService } from "../admin-dashboard/product/product.service";
import { map } from "rxjs/operators";
import { NotificationService } from "src/app/shared/notification.service";
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { Firestore, doc, updateDoc, deleteField } from '@angular/fire/firestore'; // ⇐ imported form same SDK not from firebase SDK

@Injectable({ providedIn: 'root' }) export class VmMachineService {


    channelArr = []
    newChannels = [];
    channelRow = []
    prevChannel;
    siteId: string;
    systemId: string;
    machineId: string;
    channelChanged = new Subject()
    outerIndex: number;
    innerIndex: number;
    products$ = new Observable;

    constructor(private afs: AngularFirestore,
        private config: ConfigService,
        private notificationService: NotificationService,
        private productService: ProductService) {


    }

    getChannels(siteId: string, systemId: string, machineId: string) {
        //this.newChannels = [];
        this.siteId = siteId;
        this.systemId = systemId;
        this.machineId = machineId;
        // this.products$ = this.productService.getProducts();
        // this.createSystemProductList()
        let channels$ = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId)
            .collection('channels', ref => {
                return ref.orderBy('selection', 'desc');
            }).get();

        channels$.pipe(map(async channel => {
            this.channelArr = []
            this.newChannels = []
            let product = {}
            let quantity;
            return await Promise.all(channel.docs.map(async obj => {
                if (obj.data()['productId']) {
                    product = await this.productService.getProductById(obj.data()['productId']);
                    quantity = this.onChannelSelectedInventory(obj.id)
                }
                return {
                    ...obj.data(),
                    channelId: obj.id,
                    ...product,
                    quantity: quantity
                    // ...(combArry[0] as Array<{}>).filter(t => t['id'] === obj.data()['productId'])[0]
                }
            }))
        }))
            .subscribe(data => {
                data.then(d => {
                    this.channelArr = d
                    for (let obj in this.channelArr) {
                        this.onRow(this.channelArr[obj])
                    }
                })
            })
    }



    onChannelSelected(channelId: string) {

        let channel = this.channelArr.find((element) => {
            return element.channelId == channelId
        })
        return channel;
    }

    async deleteChannel(siteId: string, systemId: string, machineId: string, channelId: string) {
        console.log(siteId, systemId, machineId, channelId)

        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId)
            .collection('channels').doc(channelId).delete()
    }

    onChannelSelectedInventory(channelId: string) {

        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(this.siteId)
            .collection('systems')
            .doc(this.systemId)
            .collection('stocks')
            .doc('product_data')
            .collection('stock_data')
            .doc(channelId)
            .valueChanges()
    }

    async updateStockInventory(channelId: string, object) {

        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(this.siteId)
            .collection('systems')
            .doc(this.systemId)
            .collection('stocks')
            .doc('product_data')
            .collection('stock_data')
            .doc(channelId)
            .update(object)
    }

    async onUpdateChannel(channelId: string, object) {
        let batch = this.afs.firestore.batch();
        let db = this.afs.firestore;
        // Set the value of 'NYC'
        let sysRef = db.collection('company')
            .doc(this.config.getCompanyId()).collection('sites').doc(this.siteId)
            .collection('systems').doc(this.systemId).collection('systemProduct');
        if (object.productId) {
            let pCheck = await sysRef.where('uid', '==', object.productId).get()
            if (pCheck.docs.length == 0)
                batch.set(sysRef.doc(object.productId), { uid: object.productId, updatedOn: moment().unix() });

            // Update the population of 'SF'
            let pRef = db.collection('company').doc(this.config.getCompanyId()).collection('products')
                .doc(object.productId).collection("channelRef").doc(channelId)
            batch.set(pRef, { channelId, siteId: this.siteId, systemId: this.systemId, machineId: this.machineId, createdOn: moment().unix() });

            let sysProChannelRef = db.collection('company').doc(this.config.getCompanyId()).collection('sites').doc(this.siteId)
                .collection('systems').doc(this.systemId).collection('systemProduct').doc(object.productId).collection('channelRef').doc(channelId);
            batch.set(sysProChannelRef, { channelId, siteId: this.siteId, systemId: this.systemId, machineId: this.machineId, createdOn: moment().unix() });

            let cRef = db.collection('company').doc(this.config.getCompanyId())
                .collection('sites').doc(this.siteId).collection('systems').doc(this.systemId)
                .collection('vmachine').doc(this.machineId).collection('channels').doc(channelId);
            console.log(object)
            batch.update(cRef, object);

            // // Commit the batch
            return batch.commit().then(async () => {

                if (object.extractionTime)
                    this.newChannels[this.outerIndex][this.innerIndex].extractionTime = object.extractionTime
                if (object.voltage)
                    this.newChannels[this.outerIndex][this.innerIndex].voltage = object.voltage
                if (object.productId) {

                    let result = await this.productService.getProductById(object.productId);

                    this.newChannels[this.outerIndex][this.innerIndex].productId = object.productId;
                    this.newChannels[this.outerIndex][this.innerIndex] = { ...this.newChannels[this.outerIndex][this.innerIndex], ...result as object }
                }

                this.channelChanged.next(this.newChannels)
            });
        } else {
            let cRef = db.collection('company').doc(this.config.getCompanyId())
                .collection('sites').doc(this.siteId).collection('systems').doc(this.systemId)
                .collection('vmachine').doc(this.machineId).collection('channels').doc(channelId)
            delete object.productId
            console.log("else",object)
            batch.update(cRef, object);
            return batch.commit().then(async () => {
                if (object.extractionTime)
                    this.newChannels[this.outerIndex][this.innerIndex].extractionTime = object.extractionTime
                if (object.voltage)
                    this.newChannels[this.outerIndex][this.innerIndex].voltage = object.voltage
                if (object.productId) {

                    let result = await this.productService.getProductById(object.productId);

                    this.newChannels[this.outerIndex][this.innerIndex].productId = object.productId;
                    this.newChannels[this.outerIndex][this.innerIndex] = { ...this.newChannels[this.outerIndex][this.innerIndex], ...result as object }
                }

                this.channelChanged.next(this.newChannels)
            });
        }
    }

    setIndexofSelectedChannel(i, j) {
        this.outerIndex = i;
        this.innerIndex = j
    }

    onRow(channel) {
        let channelNumber = channel.selection
        let a = Math.floor(this.prevChannel / 10)
        let b = Math.floor(channelNumber / 10)

        if (this.prevChannel) {
            if (a === b) {
                this.channelRow.push(channel)
            }
            else {
                this.channelRow.sort((a, b) => a.selection - b.selection);
                this.prevChannel = channelNumber
                this.newChannels.push(this.channelRow)
                this.channelRow = []
                this.channelRow.push(channel)
            }
        }
        else {
            this.channelRow.push(channel)
            this.prevChannel = channelNumber
        }
        // adding last layer
        if (channelNumber === this.channelArr[this.channelArr.length - 1].selection) {
            this.channelRow.sort((a, b) => a.selection - b.selection);
            this.newChannels.push(this.channelRow)
            this.channelRow = []
            this.channelChanged.next(this.newChannels)
        }
    }

    async deAttachProduct(channelId: string, productId: string) {

        try {
            let batch = this.afs.firestore.batch();
            let db = this.afs.firestore;
            // Set the value of 'NYC'
            let sysRef = db.collection('company')
                .doc(this.config.getCompanyId()).collection('sites').doc(this.siteId)
                .collection('systems').doc(this.systemId).collection('systemProduct').doc(productId).collection('channelRef').doc(channelId);;

            batch.delete(sysRef);

            // Update the population of 'SF'
            let pRef = db.collection('company').doc(this.config.getCompanyId()).collection('products')
                .doc(productId).collection("channelRef").doc(channelId)
            batch.delete(pRef);

            let stockRef = db.collection('company').doc(this.config.getCompanyId())
                .collection('sites').doc(this.siteId).collection('systems').doc(this.systemId)
                .collection('stocks').doc('product_data').collection('stock_data').doc(channelId)
            let stockRefCheck = await stockRef.get();
            if (stockRefCheck.exists) {

                batch.update(stockRef, {productName : deleteField(),maxLimit : deleteField() });

            }

            let cRef = db.collection('company').doc(this.config.getCompanyId())
                .collection('sites').doc(this.siteId).collection('systems').doc(this.systemId)
                .collection('vmachine').doc(this.machineId).collection('channels').doc(channelId)

                batch.update(cRef, {productId : deleteField() });



            // // Commit the batch
            return batch.commit().then(async () => {
                delete this.newChannels[this.outerIndex][this.innerIndex].productId;
                delete this.newChannels[this.outerIndex][this.innerIndex].imageUrl;

                this.channelChanged.next(this.newChannels)
            });
        } catch (err) {
            console.log(err)
        }

    }


    getMachineDetail(machineId?) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(this.siteId)
            .collection('systems')
            .doc(this.systemId)
            .collection('vmachine')
            .doc(machineId? machineId : this.machineId)
            .get()
    }

    async addCabinetToVm(siteId, systemId, machineId, object) {

        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId)

        let cabinetObj = {
            nodeId: Number(),
            haveControlledLights: true,
            lockers: [],
            index: object.index
        }
        let locker = {
            "tag": "",
            "isStateControlled": false
        }

        let getData = await path.get();

        getData.subscribe(async data => {
            let cabinetQuantity = Number(data.data()['cabinetsQuantity'] + 1);
            await path.update({ cabinetsQuantity: cabinetQuantity });

            cabinetObj.nodeId = Number(object.nodeId);
            for (let i = 0; i < 8; i++) {
                let obj = {
                    channel: i + "" + (Number(cabinetQuantity) - 1),
                    selection: Number(i + 1 + "" + (Number(cabinetQuantity) - 1))
                }
                let cabinetConfigTag = { ...locker, tag: (Number(cabinetQuantity) - 1) + "" + i }

                cabinetObj.lockers.push(cabinetConfigTag)
                await path.collection('channels').add(obj)

            }
            await path
                .collection("cabinetConfig")
                .add(cabinetObj)

        })

    }


    async addChannelToVm(siteId, systemId, machineId, object) {
        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);


        object.extractionTime = 0;
        object.voltage = 0;
        object.selection = Number(object.selection);


        let getData = await path.collection('channels', ref => ref.where('selection', '==', Number(object.selection))).get();
        getData.subscribe(data => {
            if (data.empty) {
                path.collection('channels').add(object)
            }
            else
                console.log("Found")
        })
    }

    resetMachine(siteId, systemId, machineId) {

        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        path.update({ resetMachine: true });
    }

    readVersions(siteId, systemId, machineId) {

        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        path.update({ readMachineIdentification: true, readJSDVersion: true });
    }

    resetSoldOut(siteId, systemId, machineId) {

        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        path.update({ resetSoldOut: true });
    }
    collectProductElevetor(companyId, siteId, systemId, machineId) {
        let path = this.afs.collection('company')
            .doc(companyId)
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        path.update({ collectProductElevetor: true });
    }

    createLockerSelection(siteId, systemId, machineId) {
        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        path.update({ requestMapping: true });

        let result = path.snapshotChanges();
        let subscriber = result.subscribe(async doc => {


            if (!doc.payload.data()['requestMapping']) {
                this.notificationService.showNotification('success', "Channel mapping complete");
                subscriber.unsubscribe();
            } else {
                path.collection('channels').get().subscribe(async channels => {
                    let mapping = {};
                    channels.forEach(doc => {
                        mapping[doc.data()['selection']] = doc.data()['channel']
                    })
                    await path.update({ mapping, requestMapping: false });
                });
                this.notificationService.showNotification('info', "Creating channel mapping")
            }
        })
    }

    async createSelection(siteId, systemId, machineId) {
        let path = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .doc(machineId);
        await path.update({ requestMapping: false });
        path.update({ requestMapping: true });

        let result = path.snapshotChanges();
        let subscriber = result.subscribe(doc => {
            if (!doc.payload.data()['requestMapping']) {
                this.notificationService.showNotification('success', "Channel mapping complete");
                subscriber.unsubscribe();
            } else {
                this.notificationService.showNotification('info', "Creating channel mapping")
            }
        })
    }
    createChannelFromSelection(siteId, systemId, machineId) {


        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine').doc(machineId).get().subscribe(async doc => {
                let map = doc.data()['mapping'];
                if (map) {
                    let batch = this.afs.firestore.batch();
                    for (var property in map) {
                        if (map.hasOwnProperty(property)) {

                            let confirmAvailability = await this.afs.firestore.collection('company').doc(this.config.getCompanyId())
                                .collection('sites').doc(siteId).collection('systems').doc(systemId).collection('vmachine').doc(machineId)
                                .collection("channels").where('selection', '==', Number(property)).get();

                            if (confirmAvailability.docs.length < 1) {
                                let nycRef = this.afs.firestore.collection('company').doc(this.config.getCompanyId())
                                    .collection('sites').doc(siteId).collection('systems').doc(systemId).collection('vmachine').doc(machineId).collection('channels').doc();

                                batch.set(nycRef, { selection: Number(property), extractionTime: 0.0, voltage: 0 });
                            }

                        }
                    }

                    return batch.commit().then(function () {
                        console.log("Completed")
                    });

                } else {
                    this.notificationService.showNotification("error", "No mapping available.")
                }
            });
    }

    updateChannelMapping(siteId, systemId) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .update({ generateMapping: true }).then((result) => {
                this.notificationService.showNotification('success', "Apply chages complete");
            }).catch((err) => {
                this.notificationService.showNotification('error', "Apply chages channel")
            })
    }

}

